import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const schedule = {
  path: '/schedulesCabinet',
  component: Layout,
  name: 'schedulesCabinet',
  redirect: '/schedulesCabinet/index',
  children: [{
    path: '/schedulesCabinet/index',
    component: () => import('@/views/schedulesCabinet/index'),
    name: 'schedulesCabinet.index',
    meta: {
      title: i18n.t(`message.schedule_cabinet`)
    }
  },
  {

    path: '/bunk/hospitalRooms/withbunk',
    component: () => import('@/views/schedulesCabinet/index'),
    name: 'hospitalRooms.withbunk',
    meta: {
      title: i18n.t(`message.schedule_cabinet`)
    }

  },
 ]
}

export default schedule